import React from 'react'
import { Container, Col, Row } from 'reactstrap'

import scaleImg from '../../../assets/scale.png'
import { VideoPlayer } from '../../Utils/GumletVideo'

const arrowChar = '\u2192'

export const HomePage = () => {
    return (
    <>
        <VideoPlayer videoID="68a1ae389deb1fdadc185e8a" />
        <h1 className="mt-5">Welcome to the Job Passion Type Indicator Assessment&trade; (JPTI) | Gaming Industry Edition</h1>
        <h2>Your Parents Picked Jobs. You're Designing a Life.</h2>
        
        <p>
            The old way? Find a job.{arrowChar} Fit in.{arrowChar} Grind it out.<br />
            The new way? {arrowChar} Discover who you are, and let that guide you.
        </p>
        <p>
            At the Careerz Group we're flipping the script with our <strong>Careerz Quest&trade; program</strong>,
            a powerful process powered by the <strong>Job Passion Type Indicator&trade;</strong> (JPTI) assessment
            that helps you uncover <strong>your personal Job Passion DNA&trade;</strong>. After completing
            a series of questions, we'll match you with career types you'll likely love for a lifetime.
        </p>
        <p>
            No more settling. No more guesswork.<br />
            Just clarity, confidence, and work that uniquely fits you.
        </p>


        <h2>Before You Begin: A Quick Note on How to Get the Best Results</h2>
        <p>
            This isn't a test you can "ace." There are no right answers. Just real ones.
        </p>
        <p>
            The goal? To capture a snapshot of the <strong>real, unfiltered you</strong>-the version of yourself that
            shows up when <strong>you're not trying to impress, please, or perform</strong>.
        </p>
        <p>
            You'll see a bunch of statements coming up next. For each one, rate how true it feels for you
            <strong>right now</strong>, in your current work life, not how you wish you were or how others
            expect you to be.
        </p>

        <Container fluid={true}>
            <Row style={{marginTop: 10, marginBottom: 10}}>
                <Col style={{padding: 0}} xs="12" sm="10" md="8" lg="6"><img className="d-block w-100" src={scaleImg} alt="Rating Scale" /></Col>
                <Col></Col>
            </Row>
        </Container>

        <p>
            <strong>IMPORTANT: If your answer changes depending on the situation or person, choose "DEPENDS."</strong>
        </p>
        <div style={{padding: "10px", marginBottom: "20px"}} className="alert-warning">
            <p><strong>TIPS TO KEEP IT REAL AND GET THE BEST RESULTS FOR YOU.</strong></p>
            <ol>
                <li>
                    Don't answer based on what your parents, teachers, or friends want for you.
                </li>
                    Don't answer based on what you admire in others.
                <li>
                    Don't answer based on who you're "trying" to become.
                </li>
                <li>
                    Do answer like you're writing in a private journal. No one's judging you or sharing your data. (Seriously.)
                </li>
                <li>
                    And because this is about your WORK life, consider each question as you are when working (not chillaxing with friends).
                </li>
                
            </ol>
        </div>
        
        <h2>What to Expect:</h2>
        <ul>
            <li>It usually takes 20-30 minutes to complete.</li>
            <li>You can pause and come back anytime, we'll save your spot.</li>
            <li>Remember, to improve accuracy, be honest; you can't excel consistently at everything. </li>
        </ul>

        <h2>The Report You'll Get When You Answer All the Questions:</h2>
        <p>
            As soon as you finish, you'll unlock your <strong>Job Passion DNA&trade; Profile</strong>, revealing
            your Core, Sanctioning, and Character values, along with the Job Passion Types&trade; that align with
            your true motivations and what drives you at work.
        </p>

        <p>
            <strong>Ready?</strong> Take a breath, trust yourself, and let's find out what lights you up and what
            jobs might be a perfect match.
        </p>
    </>)
}